export function formatMoney(satangs: number) {
  const currencySymbol = "฿"
  const bahts = satangs / 100
  const formattedBahts = bahts.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  return `${currencySymbol}${formattedBahts}`.replace(
    `${currencySymbol}-`,
    `-${currencySymbol}`,
  )
}
